module.exports = __webpack_public_path__ + "media/images/navbar/notif-059d41e66724df2f760ba78fea049afc.png";